import api from "api";
import { popinfo } from "component/Fancybox/Fancybox";
import { ModalBox } from "component/Modal";
import { useState } from "react";
import update from 'immutability-helper';
import _ from "lodash";

import { connect } from 'react-redux';
import stateMap from "store/stateMap";

const RoleTotalRequiredElement = (props) => {
    const RoleMemberCount = () => {
        if(props.role.TotalRequired == 0)
        {
            if(props.role.TotalJoin > 0)
            {
                return `${props.role.TotalJoin} Talent Joined`;
            }
            else
            {
                return `No Quota Applied`;
            }
        }   
        else
        {
            if(props.role.TotalJoin > 0)
            {
                return `${props.role.TotalJoin} Of ${props.role.TotalRequired} Joined`;
            }
            else
            {
                return `${props.role.TotalRequired} Required`;
            }
        }     
    }
    return (
        <>
            {RoleMemberCount()}
        </>
    )
}

/**
 * Function to update role list based on sent role
 * 
 * @param array roles 
 * @param object role 
 * @returns array mutated role list 
 */
const RolesUpdateRole = (roles, role) => {
    return update(roles, { $splice : [[
        _.findIndex(roles, { RoleID : role.RoleID })
        ,1
        ,role
    ]]});
}

const RoleJoinButton = (props) => {
    
    const [askToLeave, setAskToLeave] = useState(false);

    const [askToJoin, setAskToJoin] = useState(false);

    const JoinInitiative = () => {

        var ask = window.confirm('Are You Sure ?');

        if(!ask)
        {
            return;
        }

        var PopMessage = popinfo('loading', 'Joining Role', 'Please Wait');

        api('/Role/Join', 'post', {
            role_id      : props.role.RoleID
        }, 'Bearer ' + props.auth.token)
            .then((response) => {

                var updatedRole = response.membership.roles[_.findIndex(response.membership.roles, {RoleID : props.role.RoleID})];

                if(updatedRole.RequiredApproval && !updatedRole.ApproveDate)
                {
                    popinfo('info', 'Joining Role', 'You request to join "'+props.role.RoleName+'" has been sent, <br/> Please wait for initiator accept your request', {}, PopMessage);
                }
                else
                {
                    popinfo('ok', 'Joining Role', 'Congratulations, you have successfully joined this role', {}, PopMessage);
                }

                props.onJoin.apply(null, [ response.membership, updatedRole ]);

                setAskToJoin(false);
            })
            .catch((error) => {
                popinfo('error', 'Joining Role' , error, {}, PopMessage);
            });
    }

    const AskLeaveInitiative = (e) => {
        e.preventDefault();

        return LeaveInitiative(true);

        var currentRoleAccess = _.findIndex(props.access.roles, { RoleID : props.role.RoleID });


        if(props.access.membership && props.access.membership.MemberType == 'admin')
        {
            LeaveInitiative(true);
        }
        else if(props.access.roles.length > 1)
        {
            LeaveInitiative(true);
        }
        else
        {
            if(props.role.RequiredApproval)
            {
                if(currentRoleAccess.ApproveDate)
                {
                    LeaveInitiative(true);
                }
                else
                {
                    setAskToLeave(true);
                }
            }
            else
            {
                setAskToLeave(true);
            }
        }


    }

    const LeaveInitiative = (KeepFollow) => {
        

        var ask = window.confirm('Are You Sure ?');

        if(!ask)
        {
            return;
        }

        var PopMessage = popinfo('loading', 'Leaving Role', 'Please Wait');

        api('/Role/Leave', 'post', {
            role_id      : props.role.RoleID
            ,keep_follow  : KeepFollow
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                popinfo('ok', 'Leaving Role', 'Success', {}, PopMessage);

                setAskToLeave(false);

                props.onLeave.apply(null, [ response.membership, update(props.role, {$merge : {
                    TotalJoin : props.role.TotalJoin - 1
                }}) ]);
            })
            .catch((error) => {

                popinfo('error', 'Leaving Role' , error, {}, PopMessage);

            });
    }

    const MyButton = () => {

        var RoleAccessIndex = _.findIndex(props.access.roles, {RoleID : props.role.RoleID});

        if(RoleAccessIndex < 0)
        {
            return (
                <button className="btn btn-orange btn-small btn-block btn-role-join" onClick={(e) => {
                    e.preventDefault();

                    if(
                        props.role.RequiredApproval
                        &&
                        props.access.membership
                        &&
                        props.access.membership.MemberType == "admin"
                        &&
                        props.role.TotalJoin == props.role.TotalRequired - 1
                    )
                    {
                        return setAskToJoin(true);
                    }
                    else
                    {
                        JoinInitiative();
                    }

                }}>Join</button>
            );
        }
        else if(props.access.roles[RoleAccessIndex].ApproveDate)
        {
            return (
                <button className="btn btn-orange btn-small btn-block btn-role-join" onClick={AskLeaveInitiative}>Leave</button>
            );
        }
        else
        {
            if(props.role.RequiredApproval)
            {
                return (
                    <button className="btn btn-grey btn-small btn-block btn-role-join -has-meta-label" onClick={AskLeaveInitiative}>
                        <span className="btn-meta-label">Waiting Approval</span>
                        <span className="">Cancel</span>      
                    </button>
                );
            }
            else
            {
                return (
                    <button className="btn btn-orange btn-small btn-block btn-role-join" onClick={AskLeaveInitiative}>Leave</button>
                );  
            }
        }
    }

    return (
        <>
        {MyButton()}
        {
            askToLeave && 
            <ModalBox closeBox={() => {
                                    
                setAskToLeave(false);

            }} headerText='Leave Confirmation' >
                <div>
                    <div className="leading-text text-md">Are you still want to follow this initiative updates ?</div>
                    <br />
                    <div className="text-right">
                        <button className="btn btn-orange btn-reverse" onClick={(e) => {
                            e.preventDefault();

                            LeaveInitiative(false);
                        }}>Just Leave</button>&nbsp;
                        <button className="btn btn-orange" onClick={(e) => {
                            e.preventDefault();

                            LeaveInitiative(true);

                        }}>Keep Following</button>
                    </div>
                </div>
            </ModalBox>
        }
        {
            askToJoin && 
            <ModalBox closeBox={() => {
                                    
                setAskToJoin(false);

            }} headerText='Join Confirmation'>
                <div>
                    <div className="leading-text text-md text-left text-sm">
                        Since you are the leader of this initiative and do not require approval to join a role, joining this role will result in requests from other users currently being reviewed for this role being rejected.
                    </div>
                    <br />
                    <div className="text-right">
                        <button className="btn btn-orange  btn-reverse" onClick={(e) => {
                            e.preventDefault();

                            setAskToJoin(false);

                        }}>Cancel</button>&nbsp;
                        <button className="btn btn-orange" onClick={(e) => {
                            e.preventDefault();

                            JoinInitiative(false);
                        }}>Join Role</button>
                    </div>
                </div>
            </ModalBox>
        }
        </>
    )
}

export { RolesUpdateRole, RoleTotalRequiredElement };

export default connect( stateMap )(RoleJoinButton);